// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZodiacTimeWheel_wrapper__ecIxo {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 0;
  width: 100%;
}

.ZodiacTimeWheel_wheel__mDJHq {
  width: 100%;
  max-width: 360px;
  height: auto;
}

.ZodiacTimeWheel_activeSector__zCWay {
  fill: #a66cff;
  opacity: 1;
}

.ZodiacTimeWheel_inactiveSector__VNFJg {
  fill: transparent;
  stroke: rgba(255, 255, 255, 0.1);
  stroke-width: 1;
  opacity: 0.6;
}
`, "",{"version":3,"sources":["webpack://./src/components/ZodiacTimeWheel/ZodiacTimeWheel.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,YAAY;AACd","sourcesContent":[".wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 12px 0;\n  width: 100%;\n}\n\n.wheel {\n  width: 100%;\n  max-width: 360px;\n  height: auto;\n}\n\n.activeSector {\n  fill: #a66cff;\n  opacity: 1;\n}\n\n.inactiveSector {\n  fill: transparent;\n  stroke: rgba(255, 255, 255, 0.1);\n  stroke-width: 1;\n  opacity: 0.6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `ZodiacTimeWheel_wrapper__ecIxo`,
	"wheel": `ZodiacTimeWheel_wheel__mDJHq`,
	"activeSector": `ZodiacTimeWheel_activeSector__zCWay`,
	"inactiveSector": `ZodiacTimeWheel_inactiveSector__VNFJg`
};
export default ___CSS_LOADER_EXPORT___;
